import React from 'react'
import { FaStar } from 'react-icons/fa'
import { gbpUrl, googleRating } from 'utils/business-info'

// Trust signals shown under a booking card title. They are server rendered so
// crawlers see them. The Google rating always comes from utils/business-info;
// each hub used to hardcode its own number (4.8, 4.9).
//
// `pills` holds extra short claims for the page. Only pass claims that are
// true for that service, e.g. "Upfront fixed pricing" is wrong for helpers
// billed by the hour.
export const TrustPills = ({ pills = [] }) => (
    <div className='flex flex-wrap justify-center gap-2 px-3 pt-3 text-xs'>
        <a href={gbpUrl} target='_blank' rel='noreferrer'
            className='flex items-center gap-1 bg-white/90 text-gray-700 px-2.5 py-1 rounded-full border border-gray-200'>
            <FaStar className='text-amber-500' aria-hidden='true' />
            <span className='font-semibold'>{googleRating}</span>
            <span className='text-gray-500'>Google Rating</span>
        </a>
        {pills.map((pill) => (
            <span key={pill} className='bg-white/90 text-gray-700 px-2.5 py-1 rounded-full border border-gray-200'>{pill}</span>
        ))}
    </div>
)

// Title, subtitle and trust pills at the top of every hub's booking card.
// `headingAs` lets a page that already has its own <h1> demote the title.
// `subtitleClassName` sets the subtitle colour for overlay vs light cards.
export const BookingCardHeader = ({
    title,
    subtitle,
    headingAs: Heading = 'h1',
    pills,
    titleClassName = 'text-2xl sm:text-3xl',
    subtitleClassName = 'text-gray-600 sm:text-white/90',
}) => (
    <>
        {title &&
            <Heading className={`px-2 pt-1 font-bold text-center ${titleClassName}`}>
                {title}
            </Heading>
        }
        {subtitle &&
            <p className={`px-3 pt-2 text-center ${subtitleClassName}`}>
                {subtitle}
            </p>
        }
        <TrustPills pills={pills} />
    </>
)
